import LoanItemCard from './LoanItemCard'

export default LoanItemCard
